<template>
    <div class="card">
        <div class="card-body">
            <div id="companyForms" formGroup="companyForm">
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="client" ref='client' name="client" width="60%" v-model="preParentId" :dataSource='clients' :change='onClientChange' :fields="{text: 'name', value: 'id' }" placeholder="Client Name" popupHeight='300px' :enabled="clientsEnabled" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="state" name="state" v-model="preStateId" width="60%" :enabled='stateenabled' :dataSource='states' :fields="fields" placeholder="Country" popupHeight='300px' floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-textbox id='company' name="company" floatLabelType="Auto" width="60%" v-model="data.clientName" placeholder="Company Name"></ejs-textbox>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-textbox id='address' name="address" floatLabelType="Auto" width="60%" v-model="data.address" placeholder="Address"></ejs-textbox>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="clientSector" name="clientSector" v-model="data.sectorId" width="60%" :dataSource='sectors' :fields="{text: 'name', value: 'id' }" placeholder="Sector" popupHeight='300px' floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-textbox id='postalcode' name="postalcode" floatLabelType="Auto" width="60%" v-model="data.postcode" placeholder="Postal Code"></ejs-textbox>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="status" name="status" v-model="data.clientStatusId" width="60%" :select='onStatusChange' :dataSource='clientStatus' :fields="{text: 'name', value: 'id' }" placeholder="Status" popupHeight='300px' floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-textbox id='comments' name="comments" floatLabelType="Auto" width="60%" v-model="data.comments" placeholder="Comments"></ejs-textbox>
                    </div>
                </div>
            </div>
            <div class="contractsForm">
                <div tabindex="0" class="e-card">
                    <div class="e-card-header">
                        <div class="e-card-header-caption">
                            <div class="e-card-title">Contact Details</div>
                        </div>
                    </div>
                    <div class="e-card-content">
                        <ejs-grid ref='grid' :dataSource='contacts' :toolbar='toolbar' :editSettings='editSettings' :actionComplete="contactsActionComplete">
                            <e-columns>
                                <e-column field='contactName' headerText='Contact Name' width=100 :validationRules='{ required: true }'></e-column>
                                <e-column field='phone' headerText='Phone' width=100 :validationRules='{ regex: phoneNumber }'></e-column>
                                <e-column field='mobile' headerText='Mobile' width=100 :validationRules='{ regex: phoneNumber }'></e-column>
                                <e-column field='ext' headerText='Ext' width=100 :validationRules='{ regex: extension }'></e-column>
                                <e-column field='email' headerText='Email' width=100 :validationRules='{ email: true }'></e-column>
                                <e-column field='role' headerText='Role' width=100></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
            <div class="clientButtons">
                <div class="form-row">
                    <div class="form-group col-md-6">
                    </div>
                    <div style="text-align: right; margin-top:20px;" class="form-group col-md-6 justify-content-end">
                        <ejs-button v-if="canSave" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnSaveClick'>Save</ejs-button>
                        <ejs-button v-on:click.native='btnBackClick'>Back</ejs-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { DropDownListPlugin, MultiSelectPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { NumericTextBoxPlugin, UploaderPlugin, TextBoxPlugin, FormValidator } from "@syncfusion/ej2-vue-inputs";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../common/syncfusion'
    import apis from '../../common/network'


    Vue.use(DialogPlugin);
    Vue.use(DatePickerPlugin);
    Vue.use(NumericTextBoxPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(CheckBoxPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(MultiSelectPlugin);
    Vue.use(GridPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DialogUtility);

    export default {
        name: 'CompanyForm',
        created() {
            if (!this.$route.params.clientId) return;
            apis.protectedApi(`company/${this.$route.params.clientId}`)
                .then(response => {
                    this.data = response.data;
                    this.contacts = response.data.clientContactDetailsViewModel;
                    setTimeout(() => {
                        this.preParentId = this.data.parentId;
                    }, 1000)
                    this.populateStates(this.data.parentId);
                    this.stateenabled = false;//shouldnt be able to change state on edit
                }).catch(e => {
                    if (e.response.data.message) {
                        this.showErrorDialog(e.response.data.message);
                    }
                })
            this.clientsEnabled = false;//shouldnt be able to change client on edit
        },
        data() {
            return {
                data: {},
                contacts: [],
                fields: { text: 'name', value: 'id' },
                companyForms: '',
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: true,
                    allowAdding: true,
                    allowDeleting: true,
                    mode: 'Dialog'
                },
                states: [],
                phoneNumber: ['^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$', "Only phone number related characters are allowed."],
                extension: ['^[0-9]*$', "Only number related characters are allowed."],
                //There is a good reason for this!
                preStateId: null,
                preParentId: null,
                toolbar: ['Add', 'Edit', 'Delete'],
                canSave: (!this.$route.params.clientId && this.$store.state.permissions["Permissions.Client.Create"]) || (this.$route.params.clientId && this.$store.state.permissions["Permissions.Client.Update"]),
                options: {
                    //Initialize the CustomPlacement.
                    customPlacement: function (inputElement, errorElement) {
                        inputElement = inputElement.closest('.form-group');
                        errorElement.style.width = '60%'
                        inputElement.appendChild(errorElement);
                    },
                    rules: {
                        'client': {
                            required: true
                        },
                        'state': {
                            required: true
                        },
                        'company': {
                            required: true
                        },
                        'address': {
                            required: false
                        },
                        'clientSector': {
                            required: true
                        },
                        'postalcode': {
                            required: false
                        },
                        'status': {
                            required: true
                        },
                        'comments': {
                            required: false
                        }
                    }
                },
                stateenabled: false,
                clientsEnabled: true,
                allowFiltering: true,
            }
        },
        methods: {
            btnSaveClick: function (e) {
                e.preventDefault();
                let formStatus = this.companyForms.validate();
                if (formStatus) {
                    if (this.data.clientId) {
                        this.data.userId = this.$store.state.loggedInUserId;
                        this.data.stateId = this.preStateId;
                        this.data.parentId = this.preParentId;
                        showSpinner(document.getElementById('mainSpinner'));
                        apis.protectedApi.put(`company`, this.data)
                            .then(response => {
                                let message = { title: 'Success!', content: 'Company is updated successfully', cssClass: 'e-toast-success' };
                                this.$root.$emit('showToast', message);
                                this.$router.push({ name: "Companies" });
                                hideSpinner(document.getElementById('mainSpinner'));
                            }).catch(e => {
                                if (e.response.data.message)
                                    this.showErrorDialog(e.response.data.message);
                                hideSpinner(document.getElementById('mainSpinner'));
                            });

                    } else {
                        this.data.userId = this.$store.state.loggedInUserId;
                        this.data.clientContactDetailsViewModel = this.$refs.grid.ej2Instances.dataSource;
                        this.data.stateId = this.preStateId;
                        this.data.parentId = this.preParentId;
                        showSpinner(document.getElementById('mainSpinner'));
                        apis.protectedApi.post(`company`, this.data)
                            .then(response => {
                                let message = { title: 'Success!', content: 'Company is created successfully', cssClass: 'e-toast-success' };
                                this.$root.$emit('showToast', message);
                                this.$router.push({ name: "Companies" });
                                hideSpinner(document.getElementById('mainSpinner'));
                            }).catch(e => {
                                if (e.response.data.message)
                                    this.showErrorDialog(e.response.data.message);
                                hideSpinner(document.getElementById('mainSpinner'));
                            });
                    }
                }
            },
            onStatusChange: function (e) {
                if (e.itemData.name == "Inactive") {

                    DialogUtility.alert({
                        title: 'Alert Dialog',
                        content: 'If company goes inactive all its contracts will be inactive!',
                        position: { X: 700, Y: 200 },
                        showCloseIcon: true,
                        closeOnEscape: true,
                        animationSettings: { effect: 'Zoom' },
                        zIndex: 1100
                    });
                }
            },
            btnBackClick: function (e) {
                this.$router.push({ name: "Companies" });
            },

            onClientChange: function (e) {
                this.populateStates(this.$refs.client.ej2Instances.value, true);
            },

            populateStates: function (clientId, isChangeEvent) {
                apis.protectedApi(`utils/clientStates?clientId=${clientId}`)
                    .then(response => {
                        this.states = response.data;
                        setTimeout(() => {
                            this.preStateId = isChangeEvent ? null : this.data.stateId;
                        }, 1000)

                    }).catch(e => {
                        if (e.response.data.message)
                            this.showErrorDialog(e.response.data.message);
                    });
                this.stateenabled = true;
            },

            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
            contactsActionComplete(args) {
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    const arrayFields = ["contactName"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }
            },
        },
        computed: {
            clientStatus: () => {
                return SyncHelper.getDataManager("utils/clientstatus")
            },
            sectors: () => {
                return SyncHelper.getDataManager("utils/sectors")
            },
            clients() {

                return SyncHelper.getDataManager("utils/parentclients?userId=" + this.$store.state.loggedInUserId, "&clientId=" + this.data.parentId);
            },
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            // defines FormValidator to validate the TimePicker
            this.companyForms = new FormValidator("#companyForms", this.options);
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        },
    }
</script>

<style scoped>
    .contractsForm {
        margin-top: 90px;
    }
</style>
<style>
    .e-input-group {
        height: 30px;
    }
    .required-input .e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
    }
    .required-input.e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
    }
</style>